import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ResourceState = {
  checklists: any[];
  requestForms: any[];
  loading: boolean;
};

const initialState: ResourceState = {
  checklists: [],
  requestForms: [],
  loading: false,
};

const resourcesSlice = createSlice({
  name: 'resources',
  initialState,
  reducers: {
    setResources(
      state,
      action: PayloadAction<{ checklists: any[]; requestForms: any[] }>
    ) {
      state.checklists = Array.isArray(action.payload.checklists)
        ? action.payload.checklists
        : [];
      state.requestForms = Array.isArray(action.payload.requestForms)
        ? action.payload.requestForms
        : [];
      state.loading = false;
    },
    setResourcesLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setResources, setResourcesLoading } = resourcesSlice.actions;
export default resourcesSlice.reducer;
